import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import {
  Result, Row, Spin,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import Inspection from './Inspection';
import { externalGet } from '../../../utility/via-fetch';
import ViaContent from '../../../components/layout/ViaContent';
import ViaHeaderExternal from '../../../components/layout/ViaHeaderExternal';
import { convertEpochToDate } from './utility/inspection-util';
import ViaFooter from '../../../components/layout/ViaFooter';


/**
 * A component for displaying an External Inspection (link from email to customer).
 */
function InspectionView({ match }) {
  const inspectionKey = match.params.key;
  const [loadedInspection, setLoadedInspection] = useState(null);
  const [loadedUserGroup, setLoadedUserGroup] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMessageLoading, setIsMessageLoading] = useState(true);

  // LOAD
  useEffect(() => {
    setIsLoading(true);

    const switchLocationItems = (userGroup, inspection) => {
        if (inspection) {
            let companyName = (inspection.locationDetails != null) ? inspection.locationDetails.tradingName : null;
            companyName = (companyName == null) ? userGroup.description : companyName;
            companyName = (companyName == null) ? "" : companyName;
            userGroup.description = companyName;

            let locationEmail = (inspection.locationDetails != null) ? inspection.locationDetails.contactEmail : null;
            if (locationEmail){
                userGroup.contactEmail = locationEmail;
                userGroup.contactPhone = '';  //locations do not currently have a phone
            }

            let logo = (inspection.locationDetails != null) ? inspection.locationDetails.logoData : null;
            let logoType = (inspection.locationDetails != null) ? inspection.locationDetails.logoType : 'image/*';
            if (logo){
                userGroup.logo = logo;
                userGroup.logoType = logoType;
            }
        }
        return userGroup;
    }

    (async () => {
      try {
        const [inspection, userGroup] = await Promise.all([externalGet(`/api/inspections/external/${inspectionKey}`), externalGet(`/api/inspections/external/${inspectionKey}/group`)]);
        setLoadedInspection(inspection);
        setLoadedUserGroup(switchLocationItems(userGroup, inspection));
      } catch (error) {
        setLoadedInspection(null);
      }
      setIsLoading(false);
    })();
  }, [inspectionKey]);

  // Expiry Check
  const [linkExpired, setLinkExpired] = useState(false);
  useEffect(() => {
    if (loadedInspection && loadedInspection.viewTimeout) {
      if (convertEpochToDate(loadedInspection.viewTimeout.epochSecond) < new Date()) {
        setLinkExpired(true);
      }
    }
  }, [loadedInspection]);

  // Loading etc
  if (isLoading) {
    return (
      <Row type="flex" align="middle" justify="center">
        <Spin style={{ margin: '2em' }} />
      </Row>
    );
  }

  if (!loadedInspection || linkExpired) {
    // eslint-disable-next-line no-implied-eval
    setTimeout(() => setIsMessageLoading(false), 2000);
    return (
      <div className="via-layout" style={{ width: '100%' }}>
        <ViaHeaderExternal
          groupCompanyName={loadedUserGroup ? loadedUserGroup.description : null}
          logoImageData={loadedUserGroup ? loadedUserGroup.logo : null}
          logoDataType={loadedUserGroup ? loadedUserGroup.logoType : null}
          groupContactDetails={loadedUserGroup.contactEmail + (loadedUserGroup.contactPhone ? (' / ' + loadedUserGroup.contactPhone) : '')}
        />
        <ViaContent>
          {
          isMessageLoading
            ? (
              <Row type="flex" align="middle" justify="center">
                <Spin style={{ margin: '2em' }} />
              </Row>
            )
            : (
              <Result
                status="404"
                title={<FormattedMessage id={linkExpired ? 'linkExpiredTitle' : 'inspectionNotFound'} />}
                subTitle={<FormattedMessage id={linkExpired ? 'linkExpired' : 'inspectionLinkNotFound'} />}
              />
            )
        }
        </ViaContent>
        {linkExpired
          ? <ViaFooter inverseTheme={false} />
          : <></>}
      </div>
    );
  }

  return (
    <div className="via-layout" style={{ width: '100%' }}>
      <ViaHeaderExternal
        groupCompanyName={loadedUserGroup.description}
        logoImageData={loadedUserGroup.logo}
        logoDataType={loadedUserGroup.logoType}
        groupContactDetails={loadedUserGroup.contactEmail + (loadedUserGroup.contactPhone ? (' / ' + loadedUserGroup.contactPhone) : '')}
      />
      <ViaContent>
        <Inspection inspection={loadedInspection} />
      </ViaContent>
      <ViaFooter inverseTheme={false} />
    </div>
  );
}

InspectionView.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withRouter(InspectionView);
